import { Button } from "../../button";
import { HStack } from "../../../primitives/stack";
import type { ModalFooterConfig } from "../types";
import { useStyles } from "./footerStyles";

export const DefaultModalFooter = ({
  leftButton,
  rightButton,
  leftButtonVariant = "ghost",
  rightButtonVariant = "primary",
  onLeftPress,
  onRightPress,
}: ModalFooterConfig) => {
  if (!leftButton && !rightButton) return null;
  const styles = useStyles();

  return (
    <HStack
      alignItems="center"
      justifyContent="flex-end"
      style={styles.containerStyles}
    >
      {leftButton && (
        <Button variant={leftButtonVariant} onClick={onLeftPress}>
          {leftButton}
        </Button>
      )}

      {rightButton && (
        <Button variant={rightButtonVariant} onClick={onRightPress}>
          {rightButton}
        </Button>
      )}
    </HStack>
  );
};
